import styled from 'styled-components';
import { Icon } from 'antd';
import { GRAY_2 } from '../../../config/theme';

const StyledIcon = styled(Icon)`
  color: ${GRAY_2};
`;

export default StyledIcon;
